(() => {
    'use strict';

    function ctrl(transparencyService) {

        this.getLocationByCode = () => !this.model ? '' :
            this.selectedProgram.codes.find(v => v.value.trim() === this.selectedCode).key;

        this.programChanged = item => {
            this.model = null;
            this.selectedProgram = item;

            this.selectedProgram.codes.forEach(x => {
                if (x.key === 'Sippy Downs') {
                    x.key = 'Sunshine Coast';
                }
            });        

            this.selectedCode = this.selectedProgram.codes[0].value.trim();

            if (this.selectedCode) {
                this.getDataForCode();
            } else {
                this.noData = true;
            }
        }

        this.getDataForCode = () => {
            transparencyService.get(this.selectedCode.trim().substring(0, 6), '')
                .then(resp => {
                    if (resp.data) {
                        this.noData = false;
                        this.model = resp.data;
                    } else {
                        this.noData = true;
                        this.model = null;
                    }
                });
        }

        //const op = v => v && v.split('/')[0];

        //// minus one to correct indexing
        //this.opHigh = v => ((op(v) - 1) * 4) + '%';

        //this.opMedian = v => ((op(v) - 1) * (100 / 25)) + '%';

        //this.opLow = v => ((26 - op(v)) * 4) + '%';

        //// return true if any op field is '<5'
        //this.lessThanFive =
        //    () => this.model && (this.model.highestRank === '<5' || this.model.lowestRank === '<5' || this.model.medianRank === '<5');

        const rootNode = document.querySelector('[ng-controller*="transparency.controller"]');
        const programCode = rootNode.dataset.programCode;

        transparencyService.get('1', programCode || '')
            .then(resp => {
                this.institution = resp.data[0];

                this.institution.recentEd = +this.institution.rankOnly +
                    +this.institution.additionalOnly +
                    +this.institution.rankAdditional;

                this.programs = resp.programs;
                this.admissionsPeriod = resp.admissionsPeriod;

                // if only a single program, set it as selected - this happens on program pages
                if (this.programs.length === 1) {
                    this.programChanged(this.programs[0]);
                }
            });
    }

    angular.module('Uscapp').controller('transparency.controller', ['transparencyService', ctrl]);
})();